import { useGLTF } from '@react-three/drei';
import { PrimitiveProps } from '@react-three/fiber';
import * as React from 'react';

function Target(props: Omit<PrimitiveProps, 'object'>) {
  const { scene } = useGLTF(
    'https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/target-stand/model.gltf'
  );
  return <primitive key="01" object={scene} {...props} />;
}

export default React.memo(Target);
